import { FC } from 'react';
import {
  ITextareaField,
  ILabelValueField,
  IProductEnhancerField,
  EProductEnhancerFieldTypes
} from '../../../types';
import {
  EnhancedTagField,
  EnhancedTextarea,
  EnhancedLabelValue
} from '../components';

// TODO @Evgeniy check with strict null
export const ENHANCED_FIELD_TO_COMPONENT: Record<
  EProductEnhancerFieldTypes,
  FC<{
    field: IProductEnhancerField;
    onTagRemoveClick?: (
      fieldId: IProductEnhancerField['id'],
      tag: string
    ) => void;
    onTextAreaChange?: (fieldId: ITextareaField['id'], value: string) => void;
    onLabelValueChange?: (
      fieldId: ILabelValueField['id'],
      itemIndex: number,
      value: string
    ) => void;
  }>
> = {
  [EProductEnhancerFieldTypes.TAG]: EnhancedTagField,
  [EProductEnhancerFieldTypes.TITLE]: EnhancedTextarea,
  [EProductEnhancerFieldTypes.TEXTAREA]: EnhancedTextarea,
  [EProductEnhancerFieldTypes.LABEL_VALUE]: EnhancedLabelValue
};
